import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const depositPagoMovilService = data => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_DEPOSIT}`, data);
};
